import * as angular from "angular";
import {IController} from "angular";

export class UserAvatarCtrl implements IController {
  url: any;
  user: any;
  isMedium: boolean;
  isLarge: boolean;

}

angular
  .module('bringoz.admin.commons')
  .component('userAvatar', {
    bindings: {
      url: '<',
      user: '<',
      isMedium: '<',
      isLarge: '<'
    },
    template: require('./user-avatar.html').default,
    controller: UserAvatarCtrl
  });
